import React from 'react';
import { useTranslation } from 'react-i18next';

function MessagingBody() {
  const { t } = useTranslation();
  return <div>{t('body_of_message')}</div>;
}

export default MessagingBody;
